export default __webpack_public_path__ + "static/media/g.b3a9f5c4.svg";